<template>
  <div style="background: #eaeaea; padding-top: 40px">
    <div class="content">
      <div class="tablist" v-if="!filters.name">
        <div
          v-for="category in articleCategories"
          :v-model="category.name"
          :key="category.name"
          :class="[
            'tabitem',
            { tabitemactive: category.id == filters.categoryId }
          ]"
          @click="handleCategoryClick(category)"
        >
          {{ category.name }}
        </div>
      </div>

      <div class="views-content">
        <div
          class="views-header"
          v-if="articleCategories.length > 0 && !filters.name"
        >
          <div class="views-line"></div>
          <span>{{
            articleCategories.find(c => c.id == filters.categoryId) &&
              articleCategories.find(c => c.id == filters.categoryId).name
          }}</span>
        </div>
        <div class="header-list">
          <p
            @click="handleArticleClick(item)"
            v-for="(item, idx) in entities"
            :key="idx"
            class="header-item"
          >
            <span class="circle"></span> {{ item.name }}
          </p>
        </div>
      </div>
    </div>
    <el-pagination
      style="text-align: center; padding-bottom: 30px"
      background
      layout="prev, pager, next"
      :current-page="pagination.current"
      :page-size.sync="pagination.pageSize"
      :total="pagination.total"
      @current-change="handlePageChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { EventBus } from "@/EventBus.js";

import ArticleService from "../services/article";
import { getArticles } from "../http/api";
export default {
  data() {
    return {
      // 数据服务
      service: ArticleService,
      // 初始参数绑定
      entity: {
        enabled: true,
        approved: true,
        approveResult: "APPROVED"
      },
      // 查询参数绑定
      filters: {
        categoryId: null
      },
      // 查询排序参数绑定
      sorter: {
        field: "sequence",
        order: "DESC"
      },
      // 页面数据
      entities: [],
      // 分页参数
      pagination: {
        current: 1,
        pageSize: 12,
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      }
    };
  },
  computed: {
    ...mapState({
      articleCategories: state => state.articleCategories
    })
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        window.scrollTo(0, 0);

        const current = this.articleCategories;

        this.filters.language = this.$i18n.locale == "zh" ? "ZH" : "EN";

        if (this.$route.query["categoryId"]) {
          this.filters.categoryId = this.$route.query["categoryId"];
        } else {
          this.filters.categoryId = current[0].id;
        }

        if (this.$route.query["key"]) {
          this.filters.name = this.$route.query["key"];
        }

        this.handleParamChange();
      },
      deep: true
    }
  },
  methods: {
    handleCategoryClick(cateogry) {
      this.filters.categoryId = cateogry.id;
      this.handleParamChange();
    },
    handleArticleClick(article) {
      switch (article.linkType) {
        case "LINK":
          window.open(article.link);
          break;
        case "EXTERNAL_LINK":
          window.open(article.linkContent);
          break;
        default:
          this.$router.push({
            path: `/article/${article.id}`
          });
          break;
      }
    },
    handleParamChange() {
      this.pagination.current = 1;
      this.getEntityPage(
        this.entity,
        this.pagination,
        this.filters,
        this.sorter
      );
    },
    handlePageChange(page) {
      this.pagination.current = page;
      this.getEntityPage(
        this.entity,
        this.pagination,
        this.filters,
        this.sorter
      );
    },
    async getEntityPage(entity, pagination, filters, sorter) {
      if (filters) {
        for (const key in filters) {
          const param = filters[key];
          entity[key] = param;
        }
      }

      const pageable = {
        page: pagination.current - 1,
        size: pagination.pageSize
      };

      if (sorter) {
        pageable.sort = `${sorter.field},${
          sorter.order ? sorter.order : "DESC"
        }`;
      }
      const result = await getArticles({ ...entity, ...pageable });
      this.entities = result.content;
      this.pagination.current = result.number + 1;
      this.pagination.total = result.totalElements;
    }
  },
  async mounted() {
    const current = this.articleCategories;

    this.filters.language = this.$i18n.locale == "zh" ? "ZH" : "EN";

    if (this.$route.query["categoryId"]) {
      this.filters.categoryId = this.$route.query["categoryId"];
    } else {
      this.filters.categoryId = current[0].id;
    }

    if (this.$route.query["key"]) {
      this.filters.name = this.$route.query["key"];
    }

    this.getEntityPage(this.entity, this.pagination, this.filters, this.sorter);

    EventBus.$on("localeChange", () => {
      const current = this.articleCategories.filter(
        c => c.language == this.$i18n.locale.toUpperCase()
      );

      if (current.length > 0) {
        this.filters.categoryId = current[0].id;
        this.entities = [];
      }

      this.handleParamChange();
    });
  }
};
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
  background-color: #ffffff;
}
// .radio_button {
//   width: 201px;
//   height: 55px;
//   background: #FFFFFF;
//   border: 1px solid #DDDDDD;
// }
.tablist {
  display: flex;
  flex-direction: row;
  border-top: 1px solid #dddddd;
  border-left: 1px solid #dddddd;
}
.tabitem {
  width: 200px;
  height: 55px;
  line-height: 55px;
  text-align: center;
  background: #ffffff;
  cursor: pointer;
  border-right: 1px solid #dddddd;
}
.tabitemactive {
  background: #619a37;
  color: #ffffff;
}
.views-content {
  border: 1px solid #dddddd;
  padding: 42px 56px;
}
.views-header {
  font-size: 20px;
  font-family: FZLanTingHeiS-DB1-GBK;
  font-weight: 400;
  color: #444444;
  border-bottom: 1px solid #dddddd;
  padding-bottom: 20px;
  position: relative;
  .views-line {
    position: absolute;
    width: 79px;
    height: 2px;
    background: #619a37;
    bottom: 0;
  }
}
.header-list {
  padding-top: 40px;
  .header-item {
    border-bottom: 1px dashed #666666;
    padding: 10px 0;
    cursor: pointer;
    .circle {
      display: inline-block;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #619a37;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/viewsmore.vue